import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { registerFormioFileProvider } from '@lib/formioFileProvider';
import '@styles/tailwind.css';
import '@styles/global.scss';

// Register once at startup — all Formio forms use our file-management-service for uploads
registerFormioFileProvider();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
